import { render, staticRenderFns } from "./stores-integration.vue?vue&type=template&id=4a20ecd2&"
import script from "./stores-integration.vue?vue&type=script&lang=js&"
export * from "./stores-integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports